import { useState, useEffect } from 'react';
import useDataBean from '../../../../core/services/dataBean/useDataBean';
import { BpmService } from '../../../../core/services/BpmService';
import { _createProcess } from '../../../../core/services/dataBean/EntityCatalogVdos';



interface Props {
    idSelector: number;
    onChange: any;
    label?: string;
}

export const EstadoProcesoSelector = ({ idSelector, onChange, label }: Props) => {
    const process = useDataBean(_createProcess);
    const service = new BpmService();
    const [lista, setLista] = useState<any>([])
    const [id, setID] = useState(0);

    useEffect(() => {
        if (idSelector >= 0) {
            setID(idSelector);
        }
    }, [])

    useEffect(() => {
        getLista();
    }, [])


    useEffect(() => {
        onChange(id);
    }, [id])

    const setValue = (e: any) => {
        setID(parseInt(e));
        onChange(id);
    }

    const getLista = () => {
        process.instance.getProcessStateConstants(null).then(
            (resp) => {
                setLista(resp)
            }
        )
    }

    // const getLista = () => {
    //     service.getProcessStateConstants(null).subscribe(
    //         (resp: any) => {
    //             setLista(resp);

    //         }
    //     );
    // }

    return (
        <>
            <label>{label ?? "Estado del Proceso:"}</label>
            <select className="form-select" value={id} onChange={(e) => { setValue(e.target.value) }}>
                <option>...</option>
                {lista &&
                    lista.map((item: any, index: number) => {
                        return (
                            <option key={index} value={item.DataBeanProperties.Value} >{item.DataBeanProperties.Property}</option>
                        )
                    })
                }
            </select>
        </>
    )
}